import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { Seller } from './seller.model';
import { DateUtils } from 'ng-jhipster';
@Injectable()
export class SellerService {

    private resourceUrl = 'api/sellers';
    private resourceSearchUrl = 'api/_search/sellers';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(seller: Seller): Observable<Seller> {
        let copy: Seller = Object.assign({}, seller);
        copy.createDate = this.dateUtils.toDate(seller.createDate);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(seller: Seller): Observable<Seller> {
        let copy: Seller = Object.assign({}, seller);

        copy.createDate = this.dateUtils.toDate(seller.createDate);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Seller> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            let jsonResponse = res.json();
            jsonResponse.createDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.createDate);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }
    findAll(): Observable<Response> {
        let options = this.createRequestOption();
        console.log(options);
        return this.http.get(this.resourceUrl+"/all", options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    search(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    touch(id:number): Observable<Response> {

        return this.http.put( `${this.resourceUrl}/touch/${id}` ,null);
    }

    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].createDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].createDate);
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/seller/seller.service.ts